export enum statecode {
  Active = 0,
  Inactive = 1,
}

export enum statuscode {
  Canceled = 200630004,
  Finished = 2,
  Future = 1,
  InProgress = 200630000,
  Postponed = 200630003,
}

export enum bahai_typecode {
  InPerson = 200630000,
  Virtual = 200630001,
  Hybrid = 200630002,
}
